/**
 * Pure parsing + shaping helpers for the `lake_search_folders_by_name` tool
 * result. No React, no IO — the controller (LakeSearchFoldersByNameToolUI) and
 * the presentational view both consume these.
 */

export interface LakeSearchFoldersByNameArgs {
  name: string
  top_k?: number
}

export interface LakeFolderHit {
  path: string
  name: string
  label: string | null
  document_count: number
}

export interface LakeSearchFoldersByNameResult {
  folders: LakeFolderHit[]
  total: number
  error?: string
}

export function parseResult(
  raw: LakeSearchFoldersByNameResult | string | undefined
): LakeSearchFoldersByNameResult | null {
  if (raw == null) return null
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as LakeSearchFoldersByNameResult
    } catch {
      return { folders: [], total: 0, error: raw }
    }
  }
  return raw
}

/** Split a path like ``lake/green/contracts/2024`` into ``label`` + relative
 *  ``path`` suitable for the lake page's `?label=&path=` query. */
export function splitFolderPath(full: string): { label: string; path: string } | null {
  const segments = full.split('/').filter(Boolean)
  if (segments.length < 2 || segments[0] !== 'lake') return null
  const label = segments[1]
  const path = segments.slice(2).join('/')
  return { label, path }
}
